module.exports = __webpack_public_path__ + "static/img/indexBackground.37a107a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/indexBackground.png
// module id = Oc9q
// module chunks = 1